import type {DateRangeWithTimezone} from '@spaced-out/ui-design-system/lib/types';
import type {AnalyticsReferralsActions} from 'src/action-creators/analytics/analytics-referrals';
import type {
  SavedDashboardList,
  CurrentReferralFilters,
  SelectedReferralsFilterColumnsData,
} from 'src/types/analytics-genesis';

import {
  SET_SELECTED_DATE_RANGE,
  RECEIVE_SAVED_DASHBOARDS,
  SET_CURRENT_DASHBOARD_ID,
  SET_SELECTED_REFERRALS_FILTERS,
  CLEAR_SELECTED_FILTERS,
  RECEIVE_REFERRALS_OVERVIEW_TABLE_COLUMNS,
  RECEIVE_PROGRAMS_OVERVIEW_TABLE_COLUMNS,
  RECEIVE_JOBS_OVERVIEW_TABLE_COLUMNS,
  RECEIVE_PAYOUTS_OVERVIEW_TABLE_COLUMNS,
} from 'src/action-creators/analytics/analytics-referrals';


export type AnalyticsReferralsState = {
  selectedDateRange: DateRangeWithTimezone;
  savedDashboards: SavedDashboardList;
  currentDashboardID: string | null | undefined;
  selectedReferralFilters: CurrentReferralFilters;
  referralsOverviewTableColumnFilter: SelectedReferralsFilterColumnsData | null;
  programsOverviewTableColumnFilter: SelectedReferralsFilterColumnsData | null;
  jobsOverviewTableColumnFilter: SelectedReferralsFilterColumnsData | null;
  payoutsOverviewTableColumnFilter: SelectedReferralsFilterColumnsData | null;
};

const initialState: AnalyticsReferralsState = {
  selectedDateRange: {
    startDateUTC: null,
    startDate: null,
    endDateUTC: null,
    endDate: null,
  },
  savedDashboards: [],
  currentDashboardID: null,
  selectedReferralFilters: {
    job: [],
    program_name: [],
    source: [],
    team_member: [],
  },
  referralsOverviewTableColumnFilter: null,
  programsOverviewTableColumnFilter: null,
  jobsOverviewTableColumnFilter: null,
  payoutsOverviewTableColumnFilter: null,
};

export default (
  state: AnalyticsReferralsState | null | undefined = initialState,
  action: AnalyticsReferralsActions,
): AnalyticsReferralsState => {
  switch (action.type) {
    case SET_SELECTED_DATE_RANGE: {
      // @ts-expect-error - TS2322 - Type '{ selectedDateRange: DateRangeWithTimezone; savedDashboards?: SavedDashboardList | undefined; currentDashboardID?: string | null | undefined; ... 4 more ...; payoutsOverviewTableColumnFilter?: SelectedReferralsFilterColumnsData | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsReferralsState'.
      return {
        ...state,
        selectedDateRange: action.payload,
      };
    }
    case RECEIVE_SAVED_DASHBOARDS: {
      // @ts-expect-error - TS2322 - Type '{ savedDashboards: SavedDashboardList; selectedDateRange?: DateRangeWithTimezone | undefined; currentDashboardID?: string | null | undefined; ... 4 more ...; payoutsOverviewTableColumnFilter?: SelectedReferralsFilterColumnsData | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsReferralsState'.
      return {
        ...state,
        savedDashboards: action.payload,
      };
    }
    case SET_CURRENT_DASHBOARD_ID: {
      // @ts-expect-error - TS2322 - Type '{ currentDashboardID: string | null | undefined; selectedDateRange?: DateRangeWithTimezone | undefined; savedDashboards?: SavedDashboardList | undefined; ... 4 more ...; payoutsOverviewTableColumnFilter?: SelectedReferralsFilterColumnsData | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsReferralsState'.
      return {
        ...state,
        currentDashboardID: action.payload,
      };
    }
    case SET_SELECTED_REFERRALS_FILTERS: {
      // @ts-expect-error - TS2339 - Property 'selectedReferralFilters' does not exist on type 'AnalyticsReferralsState | null'.
      const {selectedReferralFilters} = state;
      // @ts-expect-error - TS2322 - Type '{ selectedReferralFilters: any; selectedDateRange?: DateRangeWithTimezone | undefined; savedDashboards?: SavedDashboardList | undefined; ... 4 more ...; payoutsOverviewTableColumnFilter?: SelectedReferralsFilterColumnsData | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsReferralsState'.
      return {
        ...state,
        selectedReferralFilters: {
          ...selectedReferralFilters,
          ...action.payload,
        },
      };
    }
    case CLEAR_SELECTED_FILTERS: {
      // @ts-expect-error - TS2322 - Type '{ selectedReferralFilters: { job: never[]; program_name: never[]; source: never[]; team_member: never[]; }; selectedDateRange?: DateRangeWithTimezone | undefined; savedDashboards?: SavedDashboardList | undefined; ... 4 more ...; payoutsOverviewTableColumnFilter?: SelectedReferralsFilterColumnsData | ... 1 more ... |...' is not assignable to type 'AnalyticsReferralsState'.
      return {
        ...state,
        selectedReferralFilters: {
          job: [],
          program_name: [],
          source: [],
          team_member: [],
        },
      };
    }
    case RECEIVE_REFERRALS_OVERVIEW_TABLE_COLUMNS: {
      // @ts-expect-error - TS2322 - Type '{ referralsOverviewTableColumnFilter: SelectedReferralsFilterColumnsData; selectedDateRange?: DateRangeWithTimezone | undefined; ... 5 more ...; payoutsOverviewTableColumnFilter?: SelectedReferralsFilterColumnsData | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsReferralsState'.
      return {...state, referralsOverviewTableColumnFilter: action.payload};
    }

    case RECEIVE_PROGRAMS_OVERVIEW_TABLE_COLUMNS: {
      // @ts-expect-error - TS2322 - Type '{ programsOverviewTableColumnFilter: SelectedReferralsFilterColumnsData; selectedDateRange?: DateRangeWithTimezone | undefined; ... 5 more ...; payoutsOverviewTableColumnFilter?: SelectedReferralsFilterColumnsData | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsReferralsState'.
      return {...state, programsOverviewTableColumnFilter: action.payload};
    }
    case RECEIVE_JOBS_OVERVIEW_TABLE_COLUMNS: {
      // @ts-expect-error - TS2322 - Type '{ jobsOverviewTableColumnFilter: SelectedReferralsFilterColumnsData; selectedDateRange?: DateRangeWithTimezone | undefined; ... 5 more ...; payoutsOverviewTableColumnFilter?: SelectedReferralsFilterColumnsData | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsReferralsState'.
      return {...state, jobsOverviewTableColumnFilter: action.payload};
    }
    case RECEIVE_PAYOUTS_OVERVIEW_TABLE_COLUMNS: {
      // @ts-expect-error - TS2322 - Type '{ payoutsOverviewTableColumnFilter: SelectedReferralsFilterColumnsData; selectedDateRange?: DateRangeWithTimezone | undefined; ... 5 more ...; jobsOverviewTableColumnFilter?: SelectedReferralsFilterColumnsData | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsReferralsState'.
      return {...state, payoutsOverviewTableColumnFilter: action.payload};
    }
  }
  // @ts-expect-error - TS2322 - Type 'AnalyticsReferralsState | null' is not assignable to type 'AnalyticsReferralsState'.
  return state;
};
